<template>
  <div class="row leilao-breadcrumb">
    <div class="col-12">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li v-if="nomeLeilao && nomeLote" class="breadcrumb-item">
          <router-link :to="`/leilao/index/leilao_id/${leilaoId}`">{{
            nomeLeilao
          }}</router-link>
        </li>
        <li v-if="leilaoId && nomeLote == null" class="breadcrumb-item">
          {{ nomeLeilao }}
        </li>
        <li v-if="loteId" class="breadcrumb-item active">
          lote {{ nomeLote }}
        </li>
      </ol>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      categoria: this.$route.params.categoria || null,
      leilaoId: this.$route.params.id || null,
      loteId: this.$route.params.idlote || null
    };
  },
  props: ["categorialeilao", "nomeLeilao", "nomeLote"]
};
</script>



// WEBPACK FOOTER //
// src/components/shared/BreadCrumb.vue